const TXMap2 = {
  map: undefined, // 地图对象
  mapMarker: undefined, //点标记
  mapMarkerCluster: undefined, //点聚合
  mapMultiLabel: undefined, //文本标记
  geolocation: undefined, //定位组件
  markerGeometries: [],
  clusterBubbleList: [],
  overlays: [], // 所有覆盖物
  sourceData: [], // 原始数据
  // 矢量图形
  multiCircle: undefined,
  //
  getApi(funName) {
    let script = document.createElement("script");
    script.type = "text/javascript";
    script.src = `https://map.qq.com/api/gljs?v=1.exp&key=5DXBZ-CA46D-B4244-HE4I6-2E46E-JZFNC&callback=${funName}`;
    document.body.appendChild(script);
    let locationScript = document.createElement("script");
    locationScript.type = "text/javascript";
    locationScript.src =
      "https://mapapi.qq.com/web/mapComponents/geoLocation/v/geolocation.min.js";
    document.body.appendChild(locationScript);
    window.qq = {};
  },
  initMap(options) {
    let _this = this;
    //定义地图中心点坐标
    var center = new TMap.LatLng(
      options.lat || 39.98412,
      options.lng || 116.307484
    );
    //定义map变量，调用 TMap.Map() 构造函数创建地图
    // 初始化地图中心
    _this.map = new TMap.Map(document.getElementById(options.containerId), {
      center: center //设置地图中心点坐标
    });
    if (options.useLocation) {
      _this.location();
    }
  },
  /**
   * 定位
   */
  location() {
    let _this = this;
    var geolocation = this.initGeolocation();
    geolocation.getIpLocation(
      function(position) {
        _this.setLocation(position);
      },
      function() {
        let position = {
          accuracy: 10000,
          adcode: 310106,
          addr: "",
          city: "上海市",
          district: "",
          lat: 31.22352,
          lng: 121.45591,
          module: "geolocation",
          nation: "中国",
          province: "上海市",
          type: "ip"
        };
        _this.setLocation(position);
      }
    );
  },
  /**
   * 初始化定位
   */
  initGeolocation() {
    if (this.geolocation == undefined) {
      this.geolocation = new qq.maps.Geolocation(
        "5DXBZ-CA46D-B4244-HE4I6-2E46E-JZFNC",
        "jhh"
      );
    }
    return this.geolocation;
  },
  setLocation(position) {
    this.map.setCenter(new TMap.LatLng(position.lat, position.lng));
  },
  /**
   *初始化map
   */
  txMap(options) {
    this.initMap(options);
  },
  /**
   * 初始化点标记
   */
  initMarker() {
    if (this.map == undefined) {
      new Error("请先初始化Map #txMap");
    }
    this.mapMarker = new TMap.MultiMarker({
      map: this.map,
      styles: this._makerStyle()
    });
  },
  /**初始化点聚合 */
  initMarkerCluster() {
    var _this = this;
    if (this.map == undefined) {
      new Error("请先初始化Map #txMap");
    }
    this.mapMarkerCluster = new TMap.MarkerCluster({
      map: this.map,
      geometries: [],
      enableDefaultStyle: false, //默认样式
      minimumClusterSize: 2, //最小聚合
      zoomOnClick: true, //点击聚合数字放大展开
      // gridSize: 1, //聚合算法的可聚合距离，即距离小于该值的点会聚合至一起，默认为60，以像素为单位
      averageCenter: false, //每个聚和簇的中心是否应该是聚类中所有标记的平均值
      maxZoom: 16 //采用聚合策略的最大缩放级别，若地图缩放级别大于该值，则不进行聚合，标点将全部被展开
    });
    // 聚合簇发生变化时触发
    this.mapMarkerCluster.on("cluster_changed", function(e) {
      console.log("聚合簇发生变化时触发lllllll");
      // 销毁旧聚合簇生成的覆盖物
      if (_this.clusterBubbleList.length) {
        _this.clusterBubbleList.forEach(item => {
          item.destroy();
        });
        _this.clusterBubbleList = [];
      }
      _this.markerGeometries = [];
      var clusters = _this.mapMarkerCluster.getClusters();
      console.log("点聚合信息", clusters);
      clusters.forEach(item => {
        if (item.geometries.length > 1) {
          //点聚合
          let clusterBubble = new window.ClusterBubble({
            map: _this.map,
            position: item.center,
            content: item.geometries.length
          });
          clusterBubble.on("click", () => {
            _this.map.fitBounds(item.bounds);
          });
          clusterBubble.setMap(_this.map);
          _this.clusterBubbleList.push(clusterBubble);
        } else {
          _this.markerGeometries.push({
            id: item.geometries[0].id,
            styleId: item.geometries[0].properties.styleId,
            content: item.geometries[0].properties.address,
            position: item.center
          });
        }
      });
      _this.mapMarker.setGeometries(_this.markerGeometries);
    });
    // 自定义覆盖物
    if (window.ClusterBubble === undefined) {
      window.ClusterBubble = function(options) {
        this.options = options;
        TMap.DOMOverlay.call(this, options);
      };
      window.ClusterBubble.prototype = new TMap.DOMOverlay();
      window.ClusterBubble.prototype.onInit = function(options) {
        this.content = options.content;
        this.position = options.position;
      };
      // 销毁时需要删除监听器
      window.ClusterBubble.prototype.onDestroy = function() {
        this.dom.removeEventListener("click", this.onClick);
        this.removeAllListeners();
      };
      window.ClusterBubble.prototype.onClick = function() {
        this.emit("click");
      };
      window.ClusterBubble.prototype.createDOM = function() {
        var dom = document.createElement("div");
        dom.innerText = this.content;
        if (this.content <= 20) {
          dom.classList.add("clusterBubble1");
        } else if (this.content > 20 && this.content <= 50) {
          dom.classList.add("clusterBubble2");
        } else if (this.content > 51 && this.content <= 100) {
          dom.classList.add("clusterBubble3");
        } else {
          dom.classList.add("clusterBubble4");
        }

        // 监听点击事件，实现zoomOnClick
        this.onClick = this.onClick.bind(this);
        // pc端注册click事件，移动端注册touchend事件
        dom.addEventListener("click", this.onClick);
        return dom;
      };
      window.ClusterBubble.prototype.updateDOM = function() {
        if (!_this.map) {
          return;
        }
        // 经纬度坐标转容器像素坐标
        let pixel = _this.map.projectToContainer(this.options.position);

        // 使文本框中心点对齐经纬度坐标点
        let left = pixel.getX() - this.dom.clientWidth / 2 + "px";
        let top = pixel.getY() - this.dom.clientHeight / 2 + "px";
        this.dom.style.transform = `translate(${left}, ${top})`;

        this.emit("dom_updated");
      };
    }
  },
  /**
   * 重新设置点与聚合点,并且清理之前的数据
   * @param {*} data
   */
  setMarkerAndMakerCluster(data) {
    this._clearMarkCluster();
    this._clearMark();
    this.sourceData = data;
    this.setMarker(data);
    this.setMarkerCluster(data);
  },
  /**
   * 设置点标记
   */
  setMarker(data) {
    if (this.mapMarker == undefined) {
      return;
    }
    const position = this._convertMakerPosition(data);
    this.mapMarker.add(position);
  },
  /**
   * 添加固定标记的
   * @param {*} lat
   * @param {*} lng
   */
  addAddressMarker(lat, lng) {
    const position = {
      id: "address-11010",
      styleId: "default",
      position: new TMap.LatLng(lat, lng),
      properties: { lat: lat, lng: lng, styleId: "default", address: "" },
      content: ""
    };
    this.mapMarker.updateGeometries(position);
    this.mapMarkerCluster.updateGeometries(position);
  },
  /**
   * 移除
   */
  removeAddressMarker() {
    this.mapMarker.remove("address-11010");
    this.mapMarkerCluster.remove("address-11010");
  },
  /**
   * 设置需要聚合的点
   * @param {*} data
   */
  setMarkerCluster(data) {
    if (this.mapMarker == undefined) {
      return;
    }
    const position = this._convertMakerPosition(data);
    this.mapMarkerCluster.add(position);
  },
  /**
   * 清楚点标记
   */
  _clearMark() {
    if (this.mapMarker == undefined) {
      new Error("请先初始化点标记 #initMarker");
    }
    const position = this._convertMakerPosition(this.sourceData);
    if (position.length > 0) {
      var ids = [];
      position.forEach(e => {
        ids.push(e.id);
      });
      this.mapMarker.remove(ids);
    }
  },
  /**
   * 清空聚合点
   */
  _clearMarkCluster() {
    if (this.mapMarkerCluster == undefined) {
      new Error("请先初始化点聚合 #initMarkerCluster");
    }
    console.log("清空就的点聚合");
    const position = this._convertMakerPosition(this.sourceData);
    if (position.length > 0) {
      var ids = [];
      position.forEach(e => {
        ids.push(e.id);
      });
      this.mapMarkerCluster.remove(ids);
    }
    this.clusterBubbleList.forEach(item => {
      item.destroy();
    });
    this.clusterBubbleList = [];
  },
  /**
   * 点标记=> 点图形数据
   * @param data map<string,List<data>>
   */
  _convertMakerPosition(data) {
    let geometries = [];
    var loop = (_styleId, array) => {
      if (array && array.length > 0) {
        array.forEach(el => {
          el.styleId = _styleId;
          const position = {
            id: el.orderNo,
            styleId: _styleId,
            position: new TMap.LatLng(el.latitude, el.longitude),
            properties: el,
            content: el.address
          };
          geometries.push(position);
        });
      }
    };
    let d1 = data["d1"];
    loop("d1", d1);
    let d2 = data["d2"];
    loop("d2", d2);
    let d3 = data["d3"];
    loop("d3", d3);
    let d4 = data["d4"];
    loop("d4", d4);
    return geometries;
  },
  /**
   * 标记点样式
   */
  _makerStyle() {
    return {
      d1: new TMap.MarkerStyle({
        width: 34,
        height: 42,
        anchor: {
          x: 17,
          y: 21
        },
        src: require("../../assets/images/marker/marker_1.png")
      }),
      d2: new TMap.MarkerStyle({
        width: 34,
        height: 42,
        anchor: {
          x: 17,
          y: 21
        },
        src: require("../../assets/images/marker/marker_2.png")
      }),
      d3: new TMap.MarkerStyle({
        width: 34,
        height: 42,
        anchor: {
          x: 17,
          y: 21
        },
        src: require("../../assets/images/marker/marker_3.png")
      }),
      d4: new TMap.MarkerStyle({
        width: 34,
        height: 42,
        anchor: {
          x: 17,
          y: 21
        },
        src: require("../../assets/images/marker/marker_4.png")
      }),
      default: new TMap.MarkerStyle({
        width: 34,
        height: 42,
        anchor: {
          x: 17,
          y: 21
        },
        src: require("../../assets/images/marker/marker_1.png")
      })
    };
  },
  /**
   * 初始化矢量图形
   */
  initMultiCircle() {
    this.multiCircle = new TMap.MultiCircle({ map: this.map });
  },
  initStyle() {
    //初始化样式
    // const circleGeometryArray
  },
  /**
   * 添加圆
   * @param {*} data
   */
  addGeometries(data) {
    const { id, attribute1, attribute2 } = data;
    if (attribute1 && attribute2) {
      const circleGeometryArray = [];
      for (let index = 0; index < 3; index++) {
        let radius = 1000;
        // 3km
        if (index == 0) {
          radius = 3 * 1000;
          // 5km
        } else if (index == 1) {
          radius = 5 * 1000;
          // 10km
        } else {
          radius = 10 * 1000;
        }
        const latlang = new TMap.LatLng(attribute2, attribute1);
        const circleGeometry = {
          id: `${id}-${index}`,
          styleId: `circleGeometryStyle-${index}`,
          center: latlang,
          radius: radius,
          properties: data
        };
        circleGeometryArray.push(circleGeometry);
      }
      this.multiCircle.add(circleGeometryArray);
    }
  },
  /**
   * 移除圆
   * @param {*} ids
   */
  removeGeometries(ids) {
    if (ids.length > 0) {
      const circleGeometryIds = [];
      ids.forEach(id => {
        for (let index = 0; index < 3; index++) {
          circleGeometryIds.push(`${id}-${index}`);
        }
      });
      this.multiCircle.remove(circleGeometryIds);
    }
  },
  /**
   * 初始化文本标记
   */
  initMultiLabel() {
    if (this.mapMultiLabel == undefined) {
      this.mapMultiLabel = new TMap.MultiLabel({
        map: this.map,
        styles: this._multiLabelStyle()
      });
    }
  },
  /**
   * 添加文本标签点
   * @param {*} label { id,label, attribute1, attribute2}
   */
  addMultiLabel(data) {
    if (this.mapMultiLabel == undefined) {
      throw Error("请初始化文本标记点 #initMultiLabel");
    }
    const { id, label, attribute1, attribute2 } = data;
    const geometry = {
      id: id,
      position: new TMap.LatLng(attribute2, attribute1),
      content: label,
      properties: data
    };
    this.mapMultiLabel.add(geometry);
  },
  /**
   * 移除文本标记点
   */
  removeMultiLabels(ids) {
    if (this.mapMultiLabel == undefined) {
      throw Error("请初始化文本标记点 #initMultiLabel");
    }
    this.mapMultiLabel.remove(ids);
  },
  /**
   * 文本标记样式
   */
  _multiLabelStyle() {
    return {
      label: new TMap.LabelStyle({
        color: "#3777FF", //颜色属性
        size: 20, //文字大小属性
        offset: { x: 0, y: 0 }, //文字偏移属性单位为像素
        angle: 0, //文字旋转属性
        alignment: "center", //文字水平对齐属性
        verticalAlignment: "middle" //文字垂直对齐属性
      })
    };
  }
};
export default TXMap2;



// WEBPACK FOOTER //
// ./src/components/orderMap/TXMap2.js